module.exports = __webpack_public_path__ + "static/media/hs6.085886da.jpg";